import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
// import { colors } from '../../styles';

const styles = css `
  .Testimonial_wrapper {
    margin: 0 -15px;
    column-count: 3;
    column-gap: 30px;
  }
  .Testimonial_result {
    display: inline-block;
    padding: 60px;
    background-color: #F5F5F5;
    margin: 0 0 30px 0;
  }
  .Testimonial_body {
    font-weight: 300;
    font-size: 21px;
    color: #3F3F3F;
    line-height: 40px;
    margin: 0 0 40px 0;
  }
  .Testimonial_credit {
    font-weight: 800;
    font-size: 14px;
    color: #8A8A8A;
    letter-spacing: 3px;
    text-transform: uppercase;
  }
`;

function Testimonials({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${get(page, 'meta.name')}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuAbout />
      <PageIntroBanner
        headline={get(page, 'page_intro_banner[0].headline')}
        body={get(page, 'page_intro_banner[0].text')}
      />
      <div className={styles}>
        <div className="container">
          <div className="Testimonial_wrapper">
            {
              page.testimonials.map(testimonial => (
                <div className="Testimonial_result" key={get(testimonial, 'message')}>
                  <div className="Testimonial_body" dangerouslySetInnerHTML={SanitizeHtml(get(testimonial, 'message'))} />
                  <h4 className="Testimonial_credit">{get(testimonial, 'from')}</h4>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

Testimonials.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'testimonials',
})(Testimonials);



// WEBPACK FOOTER //
// ./src/pages/Testimonials/index.js